import $ from "jquery"

export default {
  init(selector, config) {
    
  },
  finalize() {

    $('#reason_8').on('change', function() {
        if ($(this).is(':checked')) {
            $("#other-reasons").show();
        }else{
            $("#other-reasons").hide(); 
            $("#other-reasons").html();
        }
    });

    $('#reason_1').on('change', function() {
        if ($(this).is(':checked')) {
            $('#myModal').modal('show');
        }
    });

    $('#reason_4').on('change', function() {
        if ($(this).is(':checked')) {
            $('#myModal').modal('show');
        }
    });

    $('#reason_5').on('change', function() {
        if ($(this).is(':checked')) {
            $("#challenging-reasons").show();
        }else{
            $("#challenging-reasons").hide(); 
            $("#challenging-reasons").html();
        }
    });

    $('#reason_6').on('change', function() {
        if ($(this).is(':checked')) {
            $("#alternative-reasons").show();
        }else{
            $("#alternative-reasons").hide(); 
            $("#alternative-reasons").html();
        }
    });

    },

};



// WEBPACK FOOTER //
// ./scripts/routes/retake-course.js